export default __webpack_public_path__ + "static/media/80s_level_won.69d8ee9f.mp3";